import { render, staticRenderFns } from "./AddCoupon.vue?vue&type=template&id=2f9e9c1f&scoped=true"
import script from "./AddCoupon.vue?vue&type=script&lang=ts"
export * from "./AddCoupon.vue?vue&type=script&lang=ts"
import style0 from "./AddCoupon.vue?vue&type=style&index=0&id=2f9e9c1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e9c1f",
  null
  
)

export default component.exports